export default "__VITE_ASSET__DKFxmGE8__"